/**
 * Copy for the outcome toast shown when a selected folder held no files. Nothing failed — an empty
 * folder is an expected outcome — so it reads as information rather than an error, and it is stated
 * even when other folders did contribute files, so the count the user ends up with is explained.
 *
 * Shared by the two surfaces that resolve a folder selection into attachable files: the Add-files
 * picker and Matter Files' `Ask Assistant`. They describe the same situation, so they must not drift
 * into two different sentences for it.
 */
export function getEmptyFolderOutcomeMessage(addedFileCount: number, emptyFolderCount: number): string {
  if (addedFileCount === 0) {
    return emptyFolderCount === 1 ? 'No files added. Selected folder is empty.' : 'No files added. Selected folders are empty.'
  }

  const added = `${addedFileCount} ${addedFileCount === 1 ? 'file' : 'files'} added.`
  return `${added} ${emptyFolderCount === 1 ? 'Empty folder was skipped.' : 'Empty folders were skipped.'}`
}
